import axios from "axios";
import { url } from "../baseUrl";

export const InfoStore = {
  state: {
    timezones: [],
    languages: [],
    userroles: [],
    countries: []
  },
  mutations: {
    setTimezones(state, data) {
      state.timezones = data;
    },
    setLanguages(state, data) {
      state.languages = data;
    },
    setUserRoles(state, data) {
      state.userroles = data;
    },
    setCountries(state, data) {
      state.countries = data;
    }
  },
  actions: {
    getAllTimezones(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/info/timezones/",
          method: "GET"
        })
          .then(response => {
            context.commit("setTimezones", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAllLanguages(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/info/languages/",
          method: "GET"
        })
          .then(response => {
            context.commit("setLanguages", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAllUserRoles(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/info/roles/",
          method: "GET"
        })
          .then(response => {
            context.commit("setUserRoles", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAllCountries(context) {
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/info/countries/",
          method: "GET"
        })
          .then(response => {
            context.commit("setCountries", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  getters: {
    roles: state => {
      return state.userroles;
    },
    timezones: state => {
      return state.timezones;
    },
    languages: state => {
      return state.languages;
    },
    countries: state => {
      return state.countries;
    }
  }
};
